import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons under bundlers (Leaflet's images are otherwise 404).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function ComplaintMap({ lat, lng, address, reference }) {
  if (lat == null || lng == null) return null;
  const openInMaps = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  return (
    <div className="rounded-lg overflow-hidden border border-border" data-testid="complaint-map">
      <MapContainer
        center={[lat, lng]}
        zoom={16}
        scrollWheelZoom={false}
        style={{ height: 280, width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]}>
          <Popup>
            <b>{reference}</b>
            <div style={{ marginTop: 4 }}>{address}</div>
            <a
              href={openInMaps}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0f172a", fontWeight: 600 }}
            >
              Open directions →
            </a>
          </Popup>
        </Marker>
      </MapContainer>
      <div className="bg-slate-900 text-white px-3 py-2 flex items-center justify-between text-xs">
        <span className="tabular-nums">{lat.toFixed(5)}, {lng.toFixed(5)}</span>
        <a href={openInMaps} target="_blank" rel="noreferrer" className="underline underline-offset-2" data-testid="open-in-maps">
          Open in Google Maps
        </a>
      </div>
    </div>
  );
}
